import { FormEvacZoneStatus } from 'shared/types';

export const validateDeactivationForEvacZones = (props: {
  isDeactivating: boolean;
  evacZoneStatuses: FormEvacZoneStatus[];
}): boolean => {
  const { isDeactivating, evacZoneStatuses } = props;

  if (!isDeactivating) return true;

  return evacZoneStatuses.length === 0;
};
